<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      custom-class
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_BusinessAdjustmentLog')"
      @close="close"
    >
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'500px'}"
        />
        <!--      </div>
      <div slot="footer">
        <el-button size="mini" type="primary" @click="close">关闭</el-button>
        </div>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryBusinessAdjustmentLog } from '@/api/seaExport/seaExportJob'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
export default {
  name: 'BusinessAdjustLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      isPagination: true // 是否显示分页
    }
  },
  computed: {
    jobUuid() {
      return this.job.uuid
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    innerVisible() {
      if (this.visible) {
        this.fetchData()
      } else {
        this.rowData = []
      }
    }
  },
  created() {
    this.columnDefs = [
      { headerName: this.$t('CargoMsg.Cargo_Time'), field: 'dateCreated', width: 200 },
      { headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'modifiedBy_wrapped', width: 200 },
      { headerName: this.$t('FinanceManage.modifyField'), field: 'filedName', width: 200 },
      { headerName: this.$t('CargoMsg.Cargo_OriginalContent'), field: 'oldValue_wrapped', width: 200 },
      { headerName: this.$t('CargoMsg.Cargo_ChangeContent'), field: 'newValue_wrapped', width: 200 }
    ]
    // this.fetchData()
  },
  methods: {
    fetchData() {
      if (!this.jobUuid) return
      this.loading = getLoading()
      queryBusinessAdjustmentLog(this.jobUuid).then(res => {
        const richResults = this.preConversionColumn(res.data)
        this.rowData = richResults
      }).finally(() => {
        this.loading.close()
      })
    },
    preConversionColumn(data) {
      const companyCacheList = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Company)
      const userCacheList = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_User)
      const cutomJobTypeCacheList = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_CutomJobType)
      const richDatas = data.map(row => {
        let txt = row.filedName

        // 代理
        if (txt === '订舱代理' || txt === '指定货代理' || txt === '目的港代理' || txt === '起运港代理' || txt === '承运人' || txt === '委托单位' || txt === '运输公司' || txt === '仓库' || txt === '报关行') {
          companyCacheList.forEach(item => {
            const company = new Company(item)
            if (Number(company.cmpIdx) === Number(row.oldValue)) {
              row.oldValue_wrapped = company.chineseName
            }
            if (Number(company.cmpIdx) === Number(row.newValue)) {
              row.newValue_wrapped = company.chineseName
            }
          })
        }

        // 用户
        userCacheList.forEach(item => {
          const user = new User(item)
          // 修改时间
          if (Number(row.modifiedBy) === Number(user.userId)) {
            row.modifiedBy_wrapped = user.chineseName
          }

          if (txt === '客服' || txt === '操作' || txt === '销售' || txt === '海外客服' || txt === '单证' || txt === '航线负责人' || txt === '路线负责人') {
            if (Number(user.userId) === Number(row.oldValue)) {
              row.oldValue_wrapped = user.chineseName
            }
            if (Number(user.userId) === Number(row.newValue)) {
              row.newValue_wrapped = user.chineseName
            }
          }
        })

        if (txt === '是否报关' || txt === '内装箱/仓储') {
          if (txt === '内装箱/仓储' && this.job.lob !== 'SE') {
            txt = '是否仓储'
          }
          row.oldValue_wrapped = ColumnUtils.checkLabelFunc(row, row.oldValue)
          row.newValue_wrapped = ColumnUtils.checkLabelFunc(row, row.newValue)
        }

        if (txt === '揽货类型') {
          row.oldValue_wrapped = ColumnUtils.cargoSourceLabelFunction(row.oldValue)
          row.newValue_wrapped = ColumnUtils.cargoSourceLabelFunction(row.newValue)
        }
        if (txt === '业务参考号' || txt === '项目编号' || txt === '实际计费重量') {
          row.oldValue_wrapped = ColumnUtils.propertyLabelFunc(row, 'oldValue')
          row.newValue_wrapped = ColumnUtils.propertyLabelFunc(row, 'newValue')
        }
        if (txt === '业务日期') {
          row.oldValue_wrapped = this.dateColumnLabelFunc(row.oldValue)
          row.newValue_wrapped = this.dateColumnLabelFunc(row.newValue)
        }
        if (txt === '约价性质' || txt === '订舱性质') {
          row.oldValue_wrapped = ColumnUtils.bookingTermLabelFunction2(row.oldValue)
          row.newValue_wrapped = ColumnUtils.bookingTermLabelFunction2(row.newValue)
        }
        if (txt === '自定义业务类型') {
          cutomJobTypeCacheList.forEach(item => {
            const cutomJobType = item
            if (cutomJobType.code === row.oldValue) {
              row.oldValue_wrapped = cutomJobType.name
            }
            if (cutomJobType.code === row.newValue) {
              row.newValue_wrapped = cutomJobType.name
            }
          })
        }

        row.filedName = txt
        return row
      })
      // console.log('richDatas', richDatas)
      return richDatas
    },
    dateColumnLabelFunc(value) {
      const result = value || ''

      if (result !== '') {
        return result.split(' ')[0]
      }
      return result
    },
    getFiledNameFuc(data) {
      const txt = data['filedName']
      const oldValue = data.oldValue
      const newValue = data.newValue

      // if (txt === '客服' || txt === '操作' || txt === '销售' || txt === '海外客服' || txt === '单证' || txt === '航线负责人') {
      //   oldValue.labelFunction = GridLabelFunction.getInstance().companyUserLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().companyUserLabelFunc
      // }
      // if (txt === '订舱代理') {
      //   oldValue.labelFunction = GridLabelFunction.getInstance().companyBookingAgentLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().companyBookingAgentLabelFunc
      // }
      // if (txt === '指定货代理' || txt === '目的港代理' || txt === '起运港代理' || txt === '承运人') {
      //   oldValue.labelFunction = GridLabelFunction.getInstance().companyDestAgentLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().companyDestAgentLabelFunc
      // }
      // if (txt === '是否报关' || txt === '内装箱/仓储') {
      //   if (txt === '内装箱/仓储' && _job.lob != 'SE') {
      //     txt = '是否仓储'
      //   }
      //   oldValue.labelFunction = GridLabelFunction.getInstance().checkLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().checkLabelFunc
      // }

      // if (txt === '委托单位') {
      //   oldValue.labelFunction = GridLabelFunction.getInstance().companyCustomerLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().companyCustomerLabelFunc
      // }
      // if (txt === '揽货类型') {
      //   oldValue.labelFunction = ColumnUtils.getInstance().cargoSourceLabelFunction
      //   newValue.labelFunction = ColumnUtils.getInstance().cargoSourceLabelFunction
      // }
      // if (txt === '业务参考号' || txt === '项目编号' || txt === '实际计费重量') {
      //   oldValue.labelFunction = ColumnUtils.propertyLabelFunc
      //   newValue.labelFunction = ColumnUtils.propertyLabelFunc
      // }
      // if (txt === '业务日期') {
      //   oldValue.labelFunction = dateColumnLabelFunc
      //   newValue.labelFunction = dateColumnLabelFunc
      // }
      // if (txt === '约价性质') {
      //   oldValue.labelFunction = ColumnUtils.getInstance().bookingTermLabelFunction2
      //   newValue.labelFunction = ColumnUtils.getInstance().bookingTermLabelFunction2
      // }
      // if (txt === '船代') {
      //   oldValue.labelFunction = GridLabelFunction.getInstance().companyBookingAgentLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().companyBookingAgentLabelFunc
      // }
      // if (txt === '自定义业务类型') {
      //   oldValue.labelFunction = ColumnUtils.getInstance().customJobTypeLabelFunc
      //   newValue.labelFunction = ColumnUtils.getInstance().customJobTypeLabelFunc
      // }

      // if (txt === '运输公司') {
      //   oldValue.labelFunction = GridLabelFunction.getInstance().companyTruckingLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().companyTruckingLabelFunc
      // }
      // if (txt === '仓库') {
      //   oldValue.labelFunction = GridLabelFunction.getInstance().companyWareHouseLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().companyWareHouseLabelFunc
      // }
      // if (txt === '报关行') {
      //   oldValue.labelFunction = GridLabelFunction.getInstance().companyCustomsBrokerLabelFunc
      //   newValue.labelFunction = GridLabelFunction.getInstance().companyCustomsBrokerLabelFunc
      // }

      data.oldValue = oldValue
      data.newValue = newValue
      data.filedName = txt
      return txt
    },
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
</style>
